import { IonSpinner, useIonRouter, IonBackdrop, useIonViewWillLeave, IonGrid, IonText, IonImg, IonBadge, IonFab, IonFabButton, IonRefresherContent, IonRefresher, IonSegmentButton, IonSegment, useIonViewWillEnter, IonInfiniteScrollContent, IonInfiniteScroll, IonSearchbar, IonBackButton, IonButton, IonButtons, IonCard, IonCheckbox, IonCol, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonPage, IonRow, IonTitle, IonToolbar } from "@ionic/react";
import { people, createOutline } from "ionicons/icons";
import React, { useState, useEffect } from "react";
import { logoWebComponent, addOutline } from "ionicons/icons";
import { Plugins, Capacitor } from '@capacitor/core';

import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';

import { Storage } from '@capacitor/storage';   
import NServer, { UIElement, RegisterAppServices } from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";
import { showTab, updateTab } from "../components/Tabs";
import LiveChat from "../components/LiveChat";

import { MsgThread } from "../data/message";
import MessageThread from "../components/MessageThread";
import Vault from '../components/Vault';
import AppUrlListener from '../components/AppUrlListener';
import { AdsInfo, InitAdMobs, ReadyAds, ShowAds, WriteAdInfo } from "../components/Admob";
import { FilterUniqueContent } from "../data/item";

import './Main.css';  

var index = 0;
const total = 30;
var refreshTimer : any;
var cur_view = "";
var hasRandomChat = false;
var rchatUsers = 0;
var pushToken = "";
const { AdMob } = Plugins;

const Messages : React.FC = () => {
    const [searchText, setSearchText] = useState('');
    const [noMoreLoadData, setNoMoreLoadData] = useState(false);
    const [view, setView] = useState("live");
    
    const [threads, setThreads] = useState<MsgThread[]>([]);
    const [chatNoti, setChatNoti] = useState(0);
    const [liveNoti, setLiveNoti] = useState(0);
    const [reqNoti, setReqNoti] = useState(0);
    const [loading, setLoading] = useState(true);

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        index = 0;
        cur_view = "live";
        setView("live");
        getData();

        showTab();

        // refresh in next 5 secs
        refreshTimer = setInterval(() => {
            refresh();
        }, 5000);

        // initialize main components
        console.log(IonBackdrop);

        InitAdMobs();
        registerServices();
    });

    // register for push notification
    const registerServices = async () => {
        
        if (window.cordova)
        {
            // Request permission to use push notifications
            // iOS will prompt user and return if they granted permission or not
            // Android will just grant without prompting
            PushNotifications.requestPermissions().then(result => {
                if (result.receive === 'granted') {
                    // Register with Apple / Google to receive push via APNS/FCM
                    PushNotifications.register();
                } else {
                    // Show some error
                    //DEL showAlert("Request permission denied");
                }
            });

            // On success, we should be able to receive notifications
            PushNotifications.addListener('registration',
                (token: Token) => {
                    pushToken = token.value;
                }
            );

            // Show us the notification payload if the app is open on our device
            PushNotifications.addListener('pushNotificationReceived',
                (noti: PushNotificationSchema) => {
                    //DEL showAlert('Push received: ' + JSON.stringify(noti));
                }
            );

            // Method called when tapping on a notification
            PushNotifications.addListener('pushNotificationActionPerformed',
                (noti: ActionPerformed) => {
                    //DEL showAlert('Push action performed: ' + JSON.stringify(noti));
                    if (noti.notification.data.hasOwnProperty('path'))
                        router.push(noti.notification.data.path, 'back', 'pop');
                }
            );
        }

        RegisterAppServices();
    }

    useIonViewWillLeave(() => {
        clearInterval(refreshTimer);
    });

    useEffect( ()=> { 
        getData() 
    }, [searchText]);

    // when view change
    useEffect( ()=> { 
        index = 0;
        setThreads([]);
        getData();
        cur_view = view;
    }, [view]);

    // refresh timer
    const refresh = () => {
        if (index == 0 && cur_view == "live")
            getData();
    }

    // create find friend chat feature
    const CreateFFChat = () : MsgThread => {
        let title = GetStr(LANGUAGE.TXT_RANDOM_CHAT_TITLE);
        let tag = "";
        if (rchatUsers > 0)
            tag = GetStr(LANGUAGE.TXT_RCHAT_ONLINE_USERS) + rchatUsers;

        return {
            id: 3,
	        title: title,
	        header: "",
	        tag: tag,
	        avatar: "/assets/img/rchat_pic.png",
	        state: "live",
	        preview: GetStr(LANGUAGE.TXT_RANDOM_CHAT_DESC),
	        read: "yes"
        };
    }

    // load data
    const getData = async () => {

        setLoading(true);

        let v = new Vault();
        await v.read();

        var thread_type = "";
        if (cur_view != "all")
            thread_type = cur_view;

        const state = {
            id: v.account.id,
            pass: v.account.key,
            search: searchText,
            type: thread_type,
            s : index,
            e : total,
            pushToken: pushToken
        }

        var server = new NServer();
        
        await server.getList("get_messages", state);
        if (server.success)
        {
            if (cur_view != server.data.view)
            {
                setLoading(false);
                return;
            }

            hasRandomChat = server.data.random_chat == 13;

            let t = server.data.threads;
            if (index == 0)
            {
                // add custom thread
                if (hasRandomChat && cur_view == "live")
                    t.splice(2, 0, CreateFFChat());
            }
            else
                t = threads.concat(server.data.threads);

            // filter
            let filter_thread = FilterUniqueContent(t);
		            
            setThreads(filter_thread);

            if (server.data.threads.length < total)
                setNoMoreLoadData(true);

            setChatNoti(server.data.chat_noti);
            setLiveNoti(server.data.live_noti);
            setReqNoti(server.data.req_noti);
            rchatUsers = server.data.rchat_users;
        }

        setLoading(false);
	}

    const doRefresh = async (ev : any) => {
        // start from beginning
        setNoMoreLoadData(false);
        index = 0;
        
        await getData();
        ev.detail.complete();
    };

    const loadMoreData = async (ev: any) => {
        console.log("loada more");
        // increase index
        index += total;

        await getData();
        ev.target.complete();
    }  

    const doSearch = async (term : string) => {
        index = 0;
        setSearchText(term);
    }

    const changeView = (v : string) => {
        index = 0;
        setView(v);
    }

    return (
        <IonPage>
            <AppUrlListener></AppUrlListener>
            <IonContent id="chat-con-view">
                <IonRefresher  slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <IonSegment value={view} onIonChange={ (e) => { changeView(e.detail.value!) }}>
                    <IonSegmentButton className={ UIElement("live_chat") } value="live">
                        <IonLabel color={ view=="live" ? "primary" : "medium" }><b><small>{ GetStr(LANGUAGE.TXT_LIVE_CHAT) }</small></b></IonLabel>
                        {
                            liveNoti > 0 ?
                        <IonBadge className="noti-bottom">{ liveNoti }</IonBadge>
                            :
                        <div />
                        }
                    </IonSegmentButton>
                    <IonSegmentButton value="all">
                        <IonLabel color={ view=="all" ? "primary" : "medium" }><b><small>{ GetStr(LANGUAGE.TXT_CHAT_MSG_TAB) }</small></b></IonLabel>
                        {
                            chatNoti > 0 ?
                        <IonBadge className="noti-bottom">{ chatNoti }</IonBadge>
                            :
                        <div />
                        }
                    </IonSegmentButton>
                    <IonSegmentButton value="req">
                        <IonLabel color={ view=="req" ? "primary" : "medium" }><b><small>{ GetStr(LANGUAGE.TXT_CHAT_REQ_TAB) }</small></b></IonLabel>
                        {
                            reqNoti > 0 ?
                        <IonBadge className="noti-bottom">{ reqNoti }</IonBadge>
                            :
                        <div />
                        }
                    </IonSegmentButton>
                </IonSegment>
                    { /* DEL
                    <IonToolbar color="none">
                        <IonSearchbar className="search-bubble" placeholder={ GetStr(LANGUAGE.TXT_CHAT_SEARCH) } value={searchText} onIonChange={ (e) => { doSearch(e.detail.value!)}} ></IonSearchbar>
                    </IonToolbar>
                    */ }
                    {
                        threads.length > 0 ?
                    <IonCard className="flat-card">
                        <IonList>
                            {threads.map(m => <MessageThread key={m.id} thread={m} />)}
                        </IonList>

                        <IonInfiniteScroll
                            onIonInfinite={loadMoreData}
                            threshold="100px"
                            disabled={noMoreLoadData}
                        >
                            <IonInfiniteScrollContent
                                className="ion-no-padding"
                                loadingSpinner="crescent"
                            ></IonInfiniteScrollContent>
                        </IonInfiniteScroll>
                    </IonCard>
                        :
                    loading ?
                    <div className="spinnerCenter">
                        <IonSpinner name="crescent" />
                    </div>
                        :
                    <IonGrid className="ion-no-padding">
                        <IonRow>
                            <IonCol>
                            </IonCol>
                            <IonCol className="ion-text-center" size-md="8" size-lg="6" size-xl="4" size="10">
                                <div><IonText><h4>{ GetStr(LANGUAGE.TXT_INFO_CHAT_CAP) }</h4></IonText></div>
                                <div><IonImg className="info-pic" src="/assets/img/msg_pic.png" /></div>
                                <div><IonText>{ GetStr(LANGUAGE.TXT_INFO_CHAT_DESC) }</IonText></div>
                            </IonCol>
                            <IonCol>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                    }
                    { /*
                    <IonFab vertical="bottom" horizontal="end" slot="fixed">
                        <IonFabButton routerLink="/chatmsg/-1/user">
                            <IonIcon icon={addOutline} />
                        </IonFabButton>
                    </IonFab>
                    */ }
            </IonContent>
        </IonPage>
    );
};
export default Messages;